import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import { isArray, isEmpty, includes, find } from 'lodash';
import { Info, Warning } from '@material-ui/icons';

import { Modal } from '~/components';
import api from '~/services/api';
import { t } from '~/helpers';

import * as S from './styles';

export default function AlertSystem() {
  const modlaRef = useRef(null);
  const formRef = useRef(null);

  const [messages, setMessages] = useState([]);
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const { id } = useSelector((state) => state.user.profile);

  const handleGetMessages = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await api.get(`alertassistema/naolidos?usua_login=${id}`);

      setMessages(data);

      if (!isEmpty(data)) {
        const checkeds = data
          .filter((message) => message.alsi_leitura === 'S')
          .map((message) => message.alsi_codigo);

        modlaRef.current.handleOpenModal();

        setIsOpen(true);
        setCodes(checkeds);
      }
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, []);

  const handleToggleCheckbox = useCallback(({ target }) => {
    if (target.checked) setCodes((state) => [...state, Number(target.name)]);
    else setCodes((state) => state.filter((s) => s !== Number(target.name)));
  }, []);

  const handleCloseModal = useCallback(() => {
    modlaRef.current.handleCloseModal();

    setIsOpen(false);
    setMessages([]);
    setCodes([]);
  }, []);

  const handleSubmit = useCallback(async () => {
    setLoading(true);

    try {
      if (isEmpty(codes)) handleCloseModal();
      else {
        const data = codes
          .map((code) => find(messages, (message) => message.alsi_codigo === code))
          .map((code) => ({ ...code, alsi_leitura: 'S' }));

        await api.put('alertassistema', data);

        handleCloseModal();
      }
    } catch (err) {
      console.log(JSON.stringify(err.status));
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [codes, messages]);

  useEffect(() => {
    if (!isOpen) {
      const isTime = setInterval(() => {
        handleGetMessages();
      }, 200000);

      return () => clearInterval(isTime);
    }
  }, [isOpen]);

  useEffect(() => {
    handleGetMessages();
  }, []);

  const buttons = useMemo(() => [
    {
      label: 'Ok',
      callback: () => formRef.current.submitForm(),
      autoFocus: true,
      variant: 'contained',
    }
  ], []);

  return (
    <Modal
      ref={modlaRef}
      disableBackdropClick
      disableEscapeKeyDown
      title="Central de Mensagens"
      component={() => (
        <S.Wrapper ref={formRef} onSubmit={handleSubmit}>
          {
            messages.map((message, index) => (
              <S.Message key={index} color={message.alsi_marca_lido === 'S' ? 'secondary' : 'primary'}>
                <header>{message.alsi_data_registro} - {message.alsi_titulo}</header>
                <div className="__content">
                  {message.alsi_marca_lido === 'S'
                    ? <Warning />
                    : <Info />
                  }
                  <div>
                    <p>{message.alsi_mensagem}</p>
                    {message.alsi_marca_lido === 'S' && (
                      <label>
                        <input
                          type="checkbox"
                          name={message.alsi_codigo}
                          checked={includes(codes, message.alsi_codigo)}
                          onClick={handleToggleCheckbox}
                        />

                        <p>Marcar como lido</p>
                      </label>
                    )}
                  </div>
                </div>
              </S.Message>
            ))
          }
        </S.Wrapper>
      )}
      actions={buttons}
      maxWidth="sm"
      maxHeight="40vh"
      loading={loading}
    />
  )
}
